import { Actions } from './actions';
import {
  CLEAR_ERROR,
  GET_SMC_CARS_ERROR,
  GET_SMC_CARS_REQUEST,
  GET_SMC_CARS_SUCCESS,
  POST_ADD_SMC_CARS_ERROR,
} from './constants';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,

  carsList: [] as any,
};

type SMCCarsState = typeof initialState;

export const smcCarsReducer = (state: SMCCarsState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_SMC_CARS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_SMC_CARS_SUCCESS: {
      return {
        ...state,
        loading: false,
        carsList: action.payload,
      };
    }
    case GET_SMC_CARS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case POST_ADD_SMC_CARS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case CLEAR_ERROR: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    default: {
      return state;
    }
  }
};
